import React from 'react';
import MobileScrollLockedSequence from '../sequence/MobileScrollLockedSequence';

interface MobileViewProps {
  currentSection: number;
  sections: Array<{
    id: string;
    Component: React.ComponentType<{ isActive?: boolean }>;
  }>;
}

// * [COMPONENT] Mobile presentation view with discrete scroll-locked canvas sequence
// ? Replaces continuous document flow on mobile with 5 checkpoint discrete frame sequence
const MobileView: React.FC<MobileViewProps> = () => {
  return (
    <div className="app mobile-layout">
      {/* * Discrete 2D canvas sequence engine pinned to mobile viewport */}
      <main className="mobile-main-content" style={{ overflow: 'hidden' }}>
        <MobileScrollLockedSequence />
      </main>
    </div>
  );
};

export default MobileView;

